import type {RenderSlideProps} from 'yet-another-react-lightbox';

import styled from 'styled-components';
import {useController, useLightboxProps} from 'yet-another-react-lightbox';

import {ms} from '../../../../styles';
import {Image} from '../../../../uikit/Image';
import {LoadingSpinner} from '../../../../uikit/LoadingSpinner';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

type Props = RenderSlideProps;

const Container = styled(View)`
  max-width: 100%;
  max-height: 100%;
  padding: ${ms(platform.isMobileBrowser ? 0 : 64)};
`;

const ImageContainer = styled(View)`
  min-width: ${ms(100)};
  min-height: ${ms(100)};
`;

const PlaceholderContainer = styled(View)`
  align-items: center;
  flex: 1;
  justify-content: center;
`;

export const ImageSlide = ({slide}: Props) => {
  const controller = useController();
  const lightboxProps = useLightboxProps();

  // @ts-expect-error: this enables zooming @see https://yet-another-react-lightbox.com/plugins/zoom#Requirements
  slide.width = 1400;
  // @ts-expect-error: see above
  slide.height = 1400;

  const onContainerClick = () => {
    if (lightboxProps.controller.closeOnBackdropClick) {
      controller.close();
    }
  };

  const onImageClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Container onClick={onContainerClick}>
      <ImageContainer onClick={onImageClick}>
        <Image
          // @ts-expect-error TODO: figure out how to type this
          disableCache={slide.disableCache}
          placeholder={
            <PlaceholderContainer>
              <LoadingSpinner
                size={50}
                strokeInnerColor={'static.white'}
                strokeOuterColor={'static.white'}
              />
            </PlaceholderContainer>
          }
          resizeMode="contain"
          src={slide.src}
        />
      </ImageContainer>
    </Container>
  );
};
